import { Box } from '@mui/material';
import { useAppSelector } from '../../../app/hooks';
import {
  selectHSVSaturation,
  selectHSVValue,
  selectUseCustomHSVSaturation,
  selectUseCustomHSVValue,
} from '../../map/mapSlice';
import { HSVToRGB } from '../../map/mapUtils';

type ColorSlotProps = {
  value: string | null | undefined;
};

export const ColorSlot: React.FC<ColorSlotProps> = ({ value }) => {
  const saturationOverride = useAppSelector(selectUseCustomHSVSaturation);
  const valueOverride = useAppSelector(selectUseCustomHSVValue);
  const saturation = useAppSelector(selectHSVSaturation);
  const colorValue = useAppSelector(selectHSVValue);

  // Parse and validate the color value
  const parsed = JSON.parse(value || '[0, 0, 0]');
  let isValid = true;
  if (
    !Array.isArray(parsed) ||
    parsed.length !== 3 ||
    parsed.some((e) => typeof e !== 'number')
  ) {
    console.error('Invalid color value');
    isValid = false;
  }

  // Clone and convert the color array, casting it to [number, number, number]
  const color: [number, number, number] = [0, 0, 0];
  if (isValid) {
    color[0] = parsed[0] * 360;
    color[1] = parsed[1] * 100;
    color[2] = parsed[2] * 100;
  }

  return (
    <Box
      sx={{
        bgcolor: HSVToRGB(
          color,
          saturationOverride,
          valueOverride,
          saturation,
          colorValue
        ),
        height: 32,
        width: 32,
        borderRadius: 4,
      }}
    />
  );
};
